// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_eso","cls2":"PaperClaiming-cls2_Lfm PaperClaiming-cls1_eso"};